import { onUnmounted as e, ref as t } from "vue";
//#region src/utils/useAbTestPolling.ts
var n = 3e4;
function r(r, i = {}) {
	let a = i.intervalMs ?? n, o = t();
	function s() {
		o.value &&= (clearInterval(o.value), void 0);
	}
	function c() {
		s(), o.value = setInterval(async () => {
			try {
				await r();
			} catch {}
			i.shouldContinue && !i.shouldContinue() && s();
		}, a);
	}
	return e(s), {
		start: c,
		stop: s
	};
}
//#endregion
export { r as t };

//# sourceMappingURL=useAbTestPolling-p2KOWVaL.js.map